export default __webpack_public_path__ + "7477fca7cd07f82021d7cebcc7a99960.png";